<!-- cms outlet block -->
<icms-outlet-block class="w-12"
                  variant="404-page"
                  name="404page">
</icms-outlet-block>